
export interface ICashIn {
    id: number,

   
    paymentSourceCode: string,

    cashControlId: number,

    amount: number,
    operationDate: Date,
    issueDate: Date,    
    
    purpose: string,
    description: string,

    paymentId: number,
    paymentDescription: string,
    paymentTotalAmount: number,
    paymentOwnerFullName: string,

    status: string,
    statusDate: Date
    statusPurpose: string,    
  }


  export const defaultCashIn : ICashIn = {
    id: 0,
    
    paymentSourceCode: '',

    cashControlId: 0,

    amount: 0,
    operationDate: new Date(),
    issueDate: new Date(),    
    
    purpose: '',
    description: '',

    paymentId: 0,
    paymentDescription: '',
    paymentTotalAmount: 0,
    paymentOwnerFullName: '',

    status: '95',
    statusDate: new Date(),
    statusPurpose: ''
  }

  export interface ICashInSearch {
    startDate: Date,
    endDate: Date,

    description: string,
  }

 
  

